import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store'

const selectProfileState = (state: RootState) => state.profile

export const selectProfileLoading = createSelector(selectProfileState, (state) => state.loading)
export const selectAuthenticated = createSelector(selectProfileState, (state) => state.authenticated)
export const selectReady = createSelector(selectProfileState, (state) => state.ready)
export const selectAuthError = createSelector(selectProfileState, (state) => state.error)
